<template>
    <div class="atreemo-survey">
        <transition-group
            name="question"
            tag="div"
        >
            <atreemo-dynamic-input
                v-for="question in visibleQuestions"
                :key="question.id"
                :label="question.label"
                :id="question.id"
                :options="question.options"
                :required="question.required"
                :type="question.type"
                :link="question.link"
                :text="question.text"
                v-model="valueProxy[question.id]"
            />
        </transition-group>
    </div>
</template>

<script>
    import { questionShouldShow } from '../../../lib/atreemo/survey';
    import AtreemoDynamicInput from '../AtreemoDynamicInput/AtreemoDynamicInput';
    import createPropProxy from '../../../lib/prop-proxies';

    export default {
        name: 'atreemo-survey',

        components: { AtreemoDynamicInput },

        props: {
            value: {
                type: Object,
                default: () => ({}),
            },

            questions: {
                type: Array,
                default: () => ([]),
            },
        },

        computed: {
            ...createPropProxy([
                'value',
            ]),

            /**
             * Return the questions that should be displayed.
             *
             * @returns {object[]}
             */
            visibleQuestions() {
                return this.questions
                    .map((question) => ({
                        ...question,
                        visible: questionShouldShow(question, this.value),
                        options: (question.options || []).filter((option) => questionShouldShow(option, this.value)),
                    }))
                    .filter(({ visible }) => visible)
                    .filter((question, index) => {
                        const populatedFields = Object.values(this.value)
                            .filter((val) => ![null, undefined].includes(val));

                        // If the form has an initial value we are happy for the other questions to show
                        if (populatedFields.length) {
                            return true;
                        }

                        // If no questions have been answered yet, we will only show the first question
                        return index === 0;
                    });
            },
        },
    };
</script>

<style lang="scss" scoped>
    ::v-deep {
        @import "~bootstrap/scss/forms";
    }

    .question-enter-active,
    .question-leave-active {
        transition: 0.5s;
    }

    .question-enter,
    .question-leave-to {
        opacity: 0;
        transform: translateY(5px);
    }
</style>
